import { createAction } from '@reduxjs/toolkit';

/*
 * Packing actions a thunk sends too: apart from the slice, which imports the
 * thunks, so the thunks need not import it.
 */

/**
 * An addition opens the order's first item before going into it. From here
 * until the addition goes out, the screen takes nothing else, so a held
 * camera read cannot slip in between the two.
 *
 * @param {number} orderId
 */
export const packingItemOpening = createAction('operatorPacking/itemOpening');

/** @param {number} orderId - The first item is open, or could not be; the addition goes next. */
export const packingItemOpened = createAction('operatorPacking/itemOpened');

/** The sheet asking which product a code is closes: dismissed, or its choice cannot go. */
export const packingResolutionDismissed = createAction('operatorPacking/resolutionDismissed');

/**
 * The screen reads the order on it until its courier's labels come (see
 * `operatorPackingListeners`): `{orderId, until}`, `until` the time it stops.
 */
export const courierWaitStarted = createAction('operatorPacking/courierWaitStarted');

/** `{orderId, until}`: that wait is over — the labels came, the attempt failed, it ran out or the order was left. */
export const courierWaitEnded = createAction('operatorPacking/courierWaitEnded');

/** @param {number} orderId - «Revisar de nuevo»: the wait for the order's labels starts over. */
export const courierWaitRequested = createAction('operatorPacking/courierWaitRequested');
